module.exports = __webpack_public_path__ + "img/bg7.bdd84c4b.png";